import SubpageLayout from "@/components/SubpageLayout";
import { P, Section, ContactCta, BackLink } from "@/components/Prose";

const Supervision = () => (
  <SubpageLayout
    overline="VI TILBYDER"
    title="Supervision og faglig sparring"
    art="/brand/hero-dandelion.png"
    testId="page-service-supervision"
  >
    <Section title="Et rum for faglig refleksion og udvikling">
      <P>
        Arbejdet med mennesker i komplekse livssituationer stiller krav til både faglighed og til
        os som mennesker. I supervisionen tager vi udgangspunkt i situationer, dilemmaer,
        muligheder og erfaringer fra praksis. Vi undersøger, hvad der sker hos det menneske, vi
        forsøger at hjælpe, hvad der sker i os selv og i relationen – og hvilke rammer og
        betingelser der har betydning for det, der bliver muligt.
      </P>
      <P>
        Vi arbejder ud fra en traumebevidst, systemisk og helhedsorienteret forståelse og skaber
        plads til faglige, etiske og personlige refleksioner. Målet er både at styrke faglig
        sikkerhed og konkrete handlemuligheder og at få øje på ressourcer og muligheder for
        udvikling.
      </P>
      <P>
        Vi arbejder også med, hvordan fagpersoner påvirkes af arbejdet, og med at forebygge
        sekundær traumatisering og vikarierende stress.
      </P>
    </Section>

    <Section title="Fra refleksion til praksis">
      <P>
        Supervision kan tage udgangspunkt i et individuelt behov eller bruges til løbende at
        understøtte faglig udvikling og forankringen af traumebevidst tilgang. Når supervisionen
        foregår i teams, kan den også bidrage til et fælles fagligt sprog, nye perspektiver og
        udvikling af den fælles praksis.
      </P>
      <P>
        Indhold og form tilpasses den konkrete organisation, faggruppe og det, der aktuelt er
        relevant at undersøge eller udvikle.
      </P>
    </Section>

    <Section title="Faglig sparring">
      <P>
        Vi tilbyder også målrettet faglig sparring i konkrete sager og i forbindelse med faglig
        eller organisatorisk udvikling. Her kan vi sammen undersøge konkrete problemstillinger og
        muligheder ud fra traumefaglige, systemiske og helhedsorienterede perspektiver og
        identificere relevante handlemuligheder i praksis.
      </P>
      <P>
        Sparringen kan også bruges til at få øje på mønstre på tværs af sager – både det, der
        udfordrer, og det, der allerede virker. Det kan synliggøre ressourcer og
        udviklingsmuligheder og pege på områder, hvor ny viden, ændringer i praksis eller
        organisatorisk udvikling kan være relevant.
      </P>
      <P>
        På den måde bliver organisationens egne erfaringer og viden et vigtigt afsæt for den videre
        udvikling.
      </P>
    </Section>

    <ContactCta title="Hvad giver mening hos jer?">
      <P>
        Supervision og faglig sparring kan stå alene eller kombineres med undervisning og
        implementeringsstøtte som del af et længere udviklingsforløb. Kontakt os gerne, hvis I vil
        drøfte jeres behov og finde en form, der giver mening i jeres praksis.
      </P>
    </ContactCta>

    <BackLink />
  </SubpageLayout>
);

export default Supervision;
